{
  "title": "The new way to become an entrepreneur",
  "subTitle": "Let your inner innovator out",
  "logBackIn": "Log Back In",
  "or": "or",
  "logOut": "Log out",
  "signUpFree": "Sign Up Free",
  "video": "Video",
  "entrepreneurship": "Entrepreneurship",
  "entrepreneurshipSubTitle": "Simplified in three steps.",
  "build": "Build",
  "buildSubTitle": "Launch your venture from the ground up",
  "buildDescription": "Jump-start your venture or take it to the next level with step-by-step modules that sharpen your skills.",
  "showcase": "Showcase",
  "showcaseSubTitle": "Generate early engagement + interest",
  "showcaseDescription": "Flaunt your accomplishments on a project page and catch the eyes of talent, backers and door-openers.",
  "connect": "Connect",
  "connectSubTitle": "Join forces with others to amplify growth",
  "connectDescription": "Participate in events and online communities, and meet partners with skills to accelerate your venture.",
  "launchTitle": "LAUNCH A DIFFERENT WORLD.",
  "launchSubTitle1": "Entrepreneurship can be dizzying.",
  "launchSubTitle2": "Here's how we keep you stable:",
  "launchText1Part1": "A shared ",
  "launchText1Part2": "online workspace",
  "launchText1Part3": " for easy collaboration with your team",
  "launchText2Part1": "Interactive workshops",
  "launchText2Part2": " that lead you to discover answers to the right questions",
  "launchText3Part1": "Adjustable ",
  "launchText3Part2": "privacy settings",
  "launchText3Part3": " so you can control who sees your project — and who doesn't",
  "launchText4Part1": "Access to ",
  "launchText4Part2": "competitions",
  "launchText4Part3": ", online and off, to test venture validity",
  "launchText5Part1": "Awards and points",
  "launchText5Part2": " that allow fellow users to show support",
  "launchText6Part1": "Opportunities to build ",
  "launchText6Part2": "relationships",
  "launchText6Part3": ", gain resources, raise capital and get recruited",
  "buildersTitle": "Discover a Proving Ground for Unconventionals",
  "buildersSubTitle": "Take builders (like these) to fortify your innovative powers and build a project page.",
  "builder1Title": "Problem",
  "builder1Question": "What need will you meet?",
  "builder2Title": "Core Team",
  "builder2Question": "Who will you work with to launch the solution, and how will you collaborate?",
  "builder3Title": "Prototesting",
  "builder3Question": "How can you demo, test and improve your solution?",
  "builder4Title": "Competitive Landscape",
  "builder4Question": "Who are your competitors and how do you set yourself apart or change the game?",
  "signUpExploreLink": "Sign up for free + explore builders",
  "joinTitle": "Join a community of Rebels. Take your solution to the next level.",
  "getStarted": "Get Started",
  "hubTitlePart1": "Want a hub for ",
  "hubTitlePart2": "your",
  "hubTitlePart3": " innovators?",
  "hubSubTitle": "Host events, equip innovators and build a community amped to change the world.",
  "hubRequestLink": "Request an invitation to start your hub",
  "ClickHereToUpdateYourBrowser": "Click here to update your browser.",
  "OutdatedBrowserMessage": "Your browser is a tad bit outdated for this website. Things are going to look wonky if you continue.",
  "BuilderTitle": "Builder Title",
  "ViewBuilder": "view builder",
  "DueDate": "Due Date (Optional)",
  "PlaygroundTitlePart1": "ideation",
  "PlaygroundTitlePart2": "Join us on 6/1!",
  "PlaygroundPhrase": "Brainstorm game-changing ideas and settle on one that you can make real. Standout ideas will have opportunities to win prizes.",
  "AddBuilders": "Add Builders",
  "close": "close",
  "firstName": "First Name",
  "lastName": "Last Name",
  "Email": "Email",
  "Password": "Password",
  "ConfirmPassword": "Confirm Password",
  "PrivacyPolicy": "privacy policy",
  "SignUpConsent1Part1": "I consent to the usage of cookies. RebelBase utilizes cookies to keep user preferences and improve user experience. ",
  "SignUpConsent1Part2": "For details regarding how we protect your personal data, please see our ",
  "SignUpConcent2Part1": "I consent to the collection and processing of data by RebelBase.",
  "SignUpConcent2Part2": "RebelBase processes personal data to provide services on the platform. See: ",
  "SignUpConcent3Part1": "I consent to the transmission of data to the United States. RebelBase is a US company. ",
  "SignUpConcent3Part2": "To provide services to you, we will securely transfer personal data to the United States. See: ",
  "SignUpConcent4Part1": "I consent to receiving promotional email updates from RebelBase. ",
  "SignUpConcent4Part2": "RebelBase may send customers email updates to ask your opinion with a survey or marketing communications. You can unsubscribe anytime. See: ",
  "optional": ". (optional)",
  "ContactUsTitle": "Want to chat?",
  "ContactUsPhrase": "We do too! Write to us and let us know about your troubles, compliments, or general inquiry. We will get back to you within 24 hours.",
  "ContactUsMessage": "Tell Us. How we may help you?",
  "SubmitButton": "Submit",
  "agree": "By signing up, you agree to our ",
  "terms": "terms of service.",
  "signedUp?": "Already signed up?",
  "Login": "Login",
  "ForgotPassword": "Forgot your password?",
  "EmailAddress": "Email Address",
  "SendInstructions": "Send me instructions >",
  "ResetYourPassword": "Reset your password",
  "ResetButton": "Reset >",
  "instead": "instead",
  "NoAccount": "Don't have an account?",
  "Signup": "Sign Up",
  "PrivacyPolicyConsent": "Privacy Policy Consent",
  "HelloThere": "Hello there. ",
  "concentPagePart1": "We are GDPR compliant! Technically, we always have been. We have protected your privacy since the beginning but now, we updated our ",
  "and": "and",
  "concentPagePart2": "language to fit with GDPR regulations.",
  "concentPagePart3": "To continue using RebelBase, please acknowledge and consent to the following: ",
  "concent": "By consenting, you also agree to our ",
  "concentSubmitLink": "consent + submit",
  "SearchProjects": "Search Projects",
  "Search": "Search",
  "createProjectButton": "Create a Project",
  "myEventsButton": "My Events",
  "ShowingAllProjects": "Showing all projects",
  "ShowingProjects": "Showing projects",
  "for": "for",
  "in": "in",
  "Industries": "Industries",
  "NoMatches": "No Matches",
  "Projects": "Projects",
  "Admin": "Admin",
  "Notifications": "Notifications",
  "Settings": "Settings",
  "Help": "Help",
  "More": "More",
  "ClearFilters": "Clear Filters",
  "Menu": "Menu",
  "Home": "Home",
  "Browse": "Browse Projects",
  "5DayChallenge": "5 Day Challenge",
  "5Day": "5 day",
  "challenge": "challenge",
  "AboutUs": "about us",
  "LoadMore": "More"
}